<template>
  <cx-dropdown trigger="click, hover" transition="cv-slidedown" arrow>
    <span v-if="mobile" class="cx-link--stack">
      <span class="cx-link__icon"  :aria-label="$t('fontSize.fontSize')">
        <i class="far fa-font"></i>
      </span>
      <span class="cx-link__text">
        {{$t('fontSize.fontSize')}}
      </span>
    </span>
    <span v-else class="cx-link cx-link--xs">
      <span class="cx-link__icon"  :aria-label="$t('fontSize.fontSize')"><i aria-hidden="true" class="fal fa-font"></i></span>
      <span id="aa-fontsize">
        {{$t('fontSize.fontSize')}}
      </span>
      <span class="cx-link__icon"><i aria-hidden="true" class="fal fa-angle-down"></i></span>
    </span>
    <template slot="content">
      <ul class="cx-list cx-list--vertical" role="listbox" 
        aria-labelledby="aa-fontsize"
        :aria-activedescendant="`aa-fointsize-${activeFontSize}`"
        >
        <li id="aa-fontsize-0" class="cx-list__item" role="option" :aria-selected="(activeFontSize == 0) ? 'true' : 'false'">
          <a 
            tabindex="0" class="cx-link cx-link--xs" 
            :class="{ '-active': activeFontSize == 0 }"
            @click.prevent="handleFontSizeChange(0)"
            v-click-by-enter>
            {{$t('fontSize.small')}}
            <span class="cx-link__icon" v-show="activeFontSize == 0"><i class="fal fa-check"></i></span>
          </a>
        </li>
        <li id="aa-fontsize-1" class="cx-list__item" role="option" :aria-selected="(activeFontSize == 1) ? 'true' : 'false'">
          <a  
            tabindex="0" class="cx-link cx-link--xs" 
            :class="{ '-active': activeFontSize == 1 }"
            @click.prevent="handleFontSizeChange(1)"
            v-click-by-enter>
            {{$t('fontSize.medium')}}
            <span class="cx-link__icon" v-show="activeFontSize == 1"><i class="fal fa-check"></i></span>
          </a>
        </li>
        <li id="aa-fontsize-2" class="cx-list__item" role="option" :aria-selected="(activeFontSize == 2) ? 'true' : 'false'">
          <a  
            tabindex="0" class="cx-link cx-link--xs" 
            :class="{ '-active': activeFontSize == 2 }"
            @click.prevent="handleFontSizeChange(2)"
            v-click-by-enter>
            {{$t('fontSize.large')}}
            <span class="cx-link__icon" v-show="activeFontSize == 2"><i class="fal fa-check"></i></span>
          </a>
        </li>
      </ul>
    </template>
  </cx-dropdown>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'font-size-selector',
  uit() {
    return  [
      ['fontSize', [
        'fontSize',
        'small',
        'medium',
        'large',
      ]],
    ]
  },
  data() {
    return {
      activeFontSize: 0,
    }
  },
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const classList = document.documentElement.className.split(' ');
    ['fs-0', 'fs-1', 'fs-2'].forEach((c, idx) => {
      if (classList.includes(c)) {
        this.activeFontSize = idx;
      }
    });
  },
  methods: {
    handleFontSizeChange: function(size) {
      this.activeFontSize = size;
      let classList = document.documentElement.className.split(' ').filter( c => {
        return !['fs-0', 'fs-1', 'fs-2'].includes(c);
      });
      classList.push('fs-' + size);
      document.documentElement.className = classList.join(' ');
      Cookies.set('fs', 'fs-' + size, { expires: 90 });
    }
  }
};
</script>
